module.exports = __webpack_public_path__ + "static/media/pause.463dfb7c.svg";